/**
 * Enum that represents the different types of updates that can be performed on a field in the ObjectUpdates store
 */
export enum FieldChangeType {
  UPDATE = 0,
  ADD = 1,
  REMOVE = 2
}
